module.exports = __webpack_public_path__ + "Roboto-Medium.31771ce59081359d01a5.svg";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2/src/assets/fonts/Roboto-Medium.svg
// module id = ../../../../../src/assets/fonts/Roboto-Medium.svg
// module chunks = main